import { sendGoogleEvent } from '@html/_common/utils';

export default function AOSerpBreadcrumbs() {
  this.initiate = () => {
    const $breadcrumbsSection = $('.js-ao-common-breadcrumbs');

    $breadcrumbsSection.on('click', '.js-ao-common-breadcrumbs-list__breadcrumb-link', this.onClckBreadcrumb);
  };

  this.onClckBreadcrumb = () => {
    sendGoogleEvent(
      'SERP',
      'Click',
      'Breadcrumbs',
    );
  };
}
